import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import Skeleton from "../../../components/Skeleton";
import NoResultsFound from "../../../components/NoResultsFound";
import { getRemainingTickets } from "../../../redux/features/tickets/ticketService";
import Pagination from "../../../components/Pagination";
import { getAllLotteryBrandDaysCode } from "../../../redux/features/lotteryBrandDay/lotteryBrandDayService";
import { getAllLotteryBrands } from "../../../redux/features/lotteryBrand/lotteryBrandService";
import DropdownwithValue from "../../../components/DropdownValue";
import BeatLoader from "react-spinners/BeatLoader";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const RemainingTickets = () => {
  const dispatch = useDispatch();
  const brandDropdownRef = useRef(null);
  const codeDropdownRef = useRef(null);

  const { isRemainingTicketsLoading, pageCount, tickets } = useSelector(
    (state) => state.ticket.remainingTickets
  );

  const { lotteryBrandDayCode } = useSelector(
    (state) => state.lotteryBrandDay.allLotteryBrandDayCode
  );

  const { lotteries } = useSelector(
    (state) => state.lottery.allLotteryBrands
  );

  const [drawDate, setDrawDate] = useState(formatDate(new Date()));
  const [brand, setBrand] = useState(null);
  const [drawNo, setDrawNo] = useState(null);
  const [code, setCode] = useState(null);
  const [brandDayMsg, setBrandDayMsg] = useState('');
  const [brandMsg, setBrandMsg] = useState('');
  const [drawNoMsg, setDrawNoMsg] = useState('');
  const [drawDatedMsg, setDrawDateMsg] = useState('');
  const [isView, setView] = useState(false);
  const [skip, setSkip] = useState(1);
  const limit = 25;

  useEffect(() => {
    dispatch(getAllLotteryBrands({ status: true }))
  }, [dispatch]);

  const fetchAllRemainingLotteries = useCallback(
    (filters = {}) => {
      const params = {
        draw_date: drawDate,
        draw_no: drawNo,
        code: code?.code,
        skip: skip,
        limit: limit,
        ...filters,
      };
      dispatch(getRemainingTickets(params));
    },
    [dispatch, drawDate, drawNo, code, skip]
  );

  useEffect(() => {
    if (isView) {
      fetchAllRemainingLotteries();
    }
  }, [skip]);

  const handlePageChange = (pageNumber) => {
    setSkip(pageNumber);
  };

  const handleLotteryBrand = (option) => {
    setBrandMsg('');
    setCode(null);
    setBrand(option);
    dispatch(getAllLotteryBrandDaysCode({ status: true, id: option.code }));
  };

  const handleLotteryBrandDay = (option) => {
    setBrandDayMsg('');
    setCode(option);
  };

  const setDrawNumber = (value) => {
    setDrawNo(value);
    setDrawNoMsg('');
  };

  const setDate = (value) => {
    setDrawDate(value);
  };

  const viewAllRemainingLotteries = () => {
    if (!brand) {
      setBrandMsg('Lottery Brand is required.')
    }
    if (!code) {
      setBrandDayMsg('Lottery Brand day is required.')
    }
    if (!drawDate) {
      setDrawDateMsg('Draw date is required.')
    }
    if (!drawNo) {
      setDrawNoMsg('Draw Number is required.')
    }
    if (brand && code && (drawDate && drawNo)) {
      setView(true);
      fetchAllRemainingLotteries();
    }
  }

  return (
    <>
      <div className={`main-card`}>
        <div className={`main-card-body`}>
          <h1 className={`form-title ${styles.headDiv}`}>
            Remaining Tickets{" "}
          </h1>
        </div>
        <div className={`form-input-row`}>
          <div className={`form-input-col`}>
            <div className={`form-input-group`}>
              <label htmlFor='full_name' className={`form-label`}>
                Lottery Brand<span className={`required-star`}>*</span>
              </label>
              <DropdownwithValue
                ref={brandDropdownRef}
                options={lotteries}
                placeholder='Select Lottery Brand'
                onSelect={handleLotteryBrand}
                value={brand?.name}
              />
            </div>
            {brandMsg && (
              <p className={`text-danger`}>
                {brandMsg}
              </p>
            )}
          </div>
        </div>
        <div className={`form-input-row`}>
          <div className={`form-input-col`}>
            <div className={`form-input-group`}>
              <label htmlFor='full_name' className={`form-label`}>
                Lottery Brand Day<span className={`required-star`}>*</span>
              </label>
              <DropdownwithValue
                ref={codeDropdownRef}
                options={lotteryBrandDayCode}
                placeholder='Select Lottery Brand Day'
                onSelect={handleLotteryBrandDay}
                value={code?.name}
              />
            </div>
            {brandDayMsg && (
              <p className={`text-danger`}>
                {brandDayMsg}
              </p>
            )}
          </div>
        </div>
        <div className={`form-input-row`}>
          <div className={`form-input-col`}>
            <div className={`form-input-group`}>
              <label htmlFor='full_name' className={`form-label`}>
                Draw Number
              </label>
              <input
                type="text"
                value={drawNo || ''}
                onChange={(e) => setDrawNumber(e.target.value)}
                className={`form-input-default`}
                placeholder="Draw Number"
              />
            </div>
            {drawNoMsg && (
              <p className={`text-danger`}>
                {drawNoMsg}
              </p>
            )}
          </div>
        </div>
        <div className={`form-input-row`}>
          <div className={`form-input-col`}>
            <div className={`form-input-group`}>
              <label htmlFor='full_name' className={`form-label`}>
                Draw Date
              </label>
              <input
                type="date"
                value={drawDate || ''}
                onChange={(e) => setDate(e.target.value)}
                className={`form-input-default`}
                placeholder="Draw Number"
              />
            </div>
            {drawDatedMsg && (
              <p className={`text-danger`}>
                {drawDatedMsg}
              </p>
            )}
          </div>
        </div>
        <div className={`form-input-row`}>
          <button
            className={`btn-primary`}
            type='button'
            disabled={isRemainingTicketsLoading}
            onClick={viewAllRemainingLotteries}
          >
            {isRemainingTicketsLoading ? (
              <BeatLoader grade='#ffffff' />
            ) : (
              `View`
            )}
          </button>
        </div>
      </div>
      {isView &&
        <div className={`card-section`} style={{ marginTop: '20px' }}>
          <div className={`search-card`}>
            <div className={`search-card-header`}>
              <div className={`form-input-col`}>
                <h1 className={`form-title ${styles.headDiv}`}>
                  Remaining Tickets
                </h1>
              </div>
            </div>
            <div className={`search-card-body`}>
              {isRemainingTicketsLoading ? (
                <Skeleton
                  columns={["Serial No", "Brand Day Code", "Brand Name", "Draw No", "Draw Date"]}
                  rowCount={10}
                  height={20}
                />
              ) : tickets.length > 0 ? (
                <div className={`table-container`}>
                  <table className={`table`}>
                    <thead className={`thead`}>
                      <tr>
                        <th className={`theadColumnOne`}>Serial No</th>
                        <th>Brand Day Code</th>
                        <th>Brand Name</th>
                        <th>Draw No</th>
                        <th>Draw Date</th>
                      </tr>
                    </thead>
                    <tbody className={`tbody`}>
                      {tickets?.map((lottery) => (
                        <tr key={lottery.id}>
                          <td className={`tdataColumnOne`}>{lottery.code}</td>
                          <td>{lottery.lottery.lottery_brand_day.code}</td>
                          <td>{lottery.lottery.lottery_brand_day.lottery_brand.name}</td>
                          <td>{lottery.lottery.draw_no}</td>
                          <td>{lottery.lottery.draw_date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <NoResultsFound />
              )}
            </div>
            <div className={`search-card-footer`}>
              {pageCount > 0 && (
                <div className={styles.paginationContainer}>
                  <Pagination
                    currentPage={skip}
                    totalPages={pageCount}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default RemainingTickets;
